// extracted by mini-css-extract-plugin
export default {"socialMedia":"soc-media-tab_socialMedia__plfdV"};